module.exports = "pegasus/assets/tech/small/1.jpg";